/// <summary>
/// This object provides js functions for the Bluaul.VC.Widget.OneNote.Export <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 12.7.2023<br />
/// Copyright ©: EUDT GmbH 2023 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 17.7.2023                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.OneNoteExport", $.common.VisualBase, {
    data: null,
    
    _create: function () {
        var me = this;

        try {



            me.element.html("");
            // set the Visual-Name first
            me.options.invoke.vcvid = 351;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));

            //inits the super class
            me._super();
           
        } catch (e) {
            me.writeError('_create', e);
            return false;
        }
        return true;
    },

    _initHTML: function () {
        this.showMessage("", false);
     
    },

    _initEvents: function () {
        var me = this;
        try {

            me.fnd("#div-content, #div-loading").hide();

            me.fnd("#btn-login").on("click", function () { me._login() }).button();

            me.fnd("#btn-microsoft").on("click", function () {
                window.open('https://microsoft.com/devicelogin', 'Login');
                me.fnd("#btn-token").show();
                me.fnd("#btn-microsoft").hide();
                me.fnd("#btn-token").show();
            }).button().hide();

            me.fnd("#btn-token").on("click", function () {me._getToken();}).button().hide();

            me.fnd("#btn-export").on("click", function () { me._export(); }).button().hide();

        } catch (e) {
            me.writeError('_initEvents', e);
            return false;
        }
        return true;
    },

    _login: function () {
        /// <summary>
        /// This function sends the login request and receives the usercode for microsoft
        /// </summary>
        var me = this;
        try {

            var param = {Type : 1};
            me.getData( param, function (result) {

                me.data = result;
                me.fnd("#txt-user-code").val(me.data.UserCode);
                me.fnd("#btn-microsoft").show();
               
                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_login', e); return false;
        }

    },

    _getToken: function () {
        /// <summary>
        /// This function sends the request to get the access token and then fetches the notebook list
        /// </summary>
        var me = this;
        try {
        
            var param = { Type: 2, Data: me.data };
            me.getData(param, function (result) {

                me.data = result;
                me.fnd("#btn-login, #txt-user-code,#btn-microsoft,#btn-token").hide();
                me._getNoteBookList();
                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_getToken', e); return false;
        }

    },

    _getNoteBookList: function () {
        /// <summary>
        /// This function sends the request for the notebook list
        /// </summary>
        var me = this;
        var param;

        try {

            param = { Type: 3, Data: me.data };
            me.getData(param, function (result) {

                me.data = result;

                if (me.data.Error.length > 0) {
                    me.showMessage("Error-Msg: " + me.data.Error, true);
                    return true;
                }
                var list = $("<select>").attr("id", "ddl-list").addClass("vc-grid-3col");
                for (var i = 0; i < me.data.NoteBooks.length; i++) {
                    list.append($("<option>").attr('value', me.data.NoteBooks[i].id).text(me.data.NoteBooks[i].displayName));
                }

                me.fnd("#div-list").html(list);
                me.fnd("#div-content, #btn-export").show();
                me.fnd("#div-loading").hide();
                me.fnd(".file").html("");

               



                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_getNoteBookList', e); return false;
        }

    },

    _export: function () {
        /// <summary>
        /// This function the request for the html generation
        /// </summary>
        var me = this;
        try {
            var param = { Type: 4, Data: me.data, LangIds: [] };

            $.each(me.fnd(".lang"), function () {

                if ($(this).prop("checked")) {
                    param.LangIds.push($(this).val());
                }
            });
            me.fnd(".pdf,.html").html("");
            me.fnd("#div-loading").show();
            //me.fnd("#div-content").show().html(me.getLoadingIcon());
            me.data.Id = me.fnd("#ddl-list").val();

            me.getData(param, function (result) {

                var fileList = JSON.parse(result);


               
                for (var i = 0; i < fileList.length; i++) {
                    var file = me.fnd("#file-" + fileList[i].LangId + ".pdf");
                    file.html("<a href='" + fileList[i].Pdf + "' target='_blank'>Pdf</a>");
                    var file = me.fnd("#file-" + fileList[i].LangId + ".html");
                    file.html("<a href='" + fileList[i].Html + "' target='_blank'>Html</a>");

                }
                me.fnd("#div-loading").hide();
                return true;
            });

            return true;
        } catch (e) {
            me.writeError('_export', e); return false;
        }

    },

    specificInfoHandling: function (bError) {
        var me = this;
        try {
            if (bError) {
                me.fnd("#div-content, #btn-export").hide();
            }
            return true;
        } catch (e) {
            me.writeError('specificInfoHandling', e); return false;
        }
    }


});
